export { default as Img200 } from './processed/200/Big-Little-Lies-S2.jpg';
export { default as Img400 } from './processed/400/Big-Little-Lies-S2.jpg';
export { default as Imgthumb } from './processed/thumb/Big-Little-Lies-S2.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Big-Little-Lies-S2.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Big-Little-Lies-S2.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      124,
      180,
      196
    ],
    "_population": 1,
    "_hsl": [
      0.5370370370370371,
      0.3789473684210527,
      0.6274509803921569
    ]
  },
  "LightVibrant": {
    "_rgb": [
      233,
      181,
      202
    ],
    "_population": 3223,
    "_hsl": [
      0.9326923076923078,
      0.5416666666666664,
      0.8117647058823529
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      12,
      27,
      28
    ],
    "_population": 85,
    "_hsl": [
      0.5104166666666666,
      0.4,
      0.0784313725490196
    ]
  },
  "Muted": {
    "_rgb": [
      143,
      137,
      118
    ],
    "_population": 3139,
    "_hsl": [
      0.12666666666666662,
      0.1004016064257028,
      0.5117647058823529
    ]
  },
  "LightMuted": {
    "_rgb": [
      179,
      212,
      203
    ],
    "_population": 1885,
    "_hsl": [
      0.4545454545454544,
      0.2773109243697482,
      0.7666666666666666
    ]
  },
  "DarkMuted": {
    "_rgb": [
      50,
      67,
      88
    ],
    "_population": 1237,
    "_hsl": [
      0.5921052631578947,
      0.2753623188405797,
      0.27058823529411763
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Big-Little-Lies-S2.js